export const categories = [
  {
    slug: 'xin-li-tiao-shi',
    name: '心理调适',
    description: '帮助年轻妈妈应对角色转变中的情绪波动与心理挑战，找到内心平衡。',
    icon: 'ri-heart-line',
  },
  {
    slug: 'ke-xue-yu-er',
    name: '科学育儿',
    description: '基于儿童发展心理学的科学养育方法，让育儿更轻松、更有效。',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'chan-hou-hui-fu',
    name: '产后恢复',
    description: '从身体恢复到体态重塑，帮助妈妈们重拾健康与自信。',
    icon: 'ri-run-line',
  },
  {
    slug: 'qin-zi-guan-xi',
    name: '亲子关系',
    description: '构建亲密健康的亲子关系，让爱与理解在家庭中流动。',
    icon: 'ri-group-line',
  },
  {
    slug: 'zi-wo-ti-sheng',
    name: '自我提升',
    description: '在母亲角色之外，持续学习与成长，活出属于自己的精彩。',
    icon: 'ri-star-line',
  },
];